import CharacterTracker from "./CharacterTracker";

export default class CharacterModel {
    /**
     * @constructor 
     * @param {Object} param
     * @param {string} param.id
     * @param {string} param.name
     * @param {string} param.avatarImageId
     * @param {Array<string>} param.emotions
     * @param {Array<CharacterTracker>} param.trackers
     */
    constructor({ id, name, avatarImageId, emotions, trackers }) {
        this._id = id;
        this._name = name;
        this._avatarImageId = avatarImageId;
        this._emotions = emotions;
        this._trackers = trackers;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get avatarImageId() {
        return this._avatarImageId;
    }

    get emotions() {
        return this._emotions;
    }

    get trackers() {
        return this._trackers;
    }

    updateTrackerRelatively(trackerId, value) {
        const tracker = this._trackers.find(tracker => tracker.id === trackerId);
        if (!tracker) {
            console.warn(`Tracker with id ${trackerId} not found on character ${this.name}.`);
            return;
        }

        tracker.value += value;
    }

    setTrackerValue(trackerId, value) {
        const tracker = this._trackers.find(tracker => tracker.id === trackerId);
        if (!tracker) {
            console.warn(`Tracker with id ${trackerId} not found on character ${this.name}.`);
            return;
        }

        tracker.value = value;
    }

    getTrackerById(trackerId) {
        return this._trackers.find(tracker => tracker.id === trackerId);
    }

    toObject() {
        return {
            id: this.id,
            name: this.name,
            avatarImageId: this.avatarImageId,
            emotions: this.emotions,
            trackers: this.trackers.map(tracker => tracker.toObject()),
        };
    }

    snapshot() {
        return {
            id: this.id,
            trackers: this.trackers.map(tracker => tracker.toObject()),
        };
    }
}